
import { Component } from 'nuxt-property-decorator'
import IconsMixin from '~/mixins/icons.mixin'

@Component
export default class IconCheckMark extends IconsMixin {
}
